const walls = [
    // 4
    { x0: 0, y0: 0, x1: 200, y1: 10 },
    { x0: 300, y0: 0, x1: 500, y1: 10 },
    { x0: 200, y0: 200, x1: 310, y1: 210 },
    { x0: 0, y0: 0, x1: 10, y1: 400 },
    { x0: 200, y0: 0, x1: 210, y1: 200 },
    { x0: 300, y0: 0, x1: 310, y1: 200 },
    { x0: 0, y0: 400, x1: 300, y1: 410 },
    { x0: 300, y0: 400, x1: 310, y1: 600 },
    { x0: 300, y0: 600, x1: 510, y1: 610 },
    { x0: 500, y0: 0, x1: 510, y1: 240 },
    { x0: 500, y0: 350, x1: 510, y1: 600 },
    // 0
    { x0: 600, y0: 0, x1: 610, y1: 240 },
    { x0: 600, y0: 350, x1: 610, y1: 600 },
    { x0: 1100, y0: 0, x1: 1110, y1: 240 },
    { x0: 1100, y0: 350, x1: 1110, y1: 600 },
    { x0: 600, y0: 0, x1: 1110, y1: 10 },
    { x0: 600, y0: 600, x1: 1110, y1: 610 },
    { x0: 800, y0: 400, x1: 900, y1: 410 },
    { x0: 800, y0: 200, x1: 900, y1: 210 },
    { x0: 800, y0: 200, x1: 810, y1: 410 },
    { x0: 900, y0: 200, x1: 910, y1: 410 },
    // 4
    { x0: 1200, y0: 0, x1: 1400, y1: 10 },
    { x0: 1500, y0: 0, x1: 1700, y1: 10 },
    { x0: 1400, y0: 200, x1: 1510, y1: 210 },
    { x0: 1200, y0: 0, x1: 1210, y1: 240 },
    { x0: 1200, y0: 350, x1: 1210, y1: 400 },
    { x0: 1400, y0: 0, x1: 1410, y1: 200 },
    { x0: 1500, y0: 0, x1: 1510, y1: 200 },
    { x0: 1200, y0: 400, x1: 1500, y1: 410 },
    { x0: 1500, y0: 400, x1: 1510, y1: 600 },
    { x0: 1500, y0: 600, x1: 1710, y1: 610 },
    { x0: 1700, y0: 0, x1: 1710, y1: 600 },
    // Connector 1
    { x0: 500, y0: 240, x1: 610, y1: 250},
    { x0: 500, y0: 350, x1: 610, y1: 360},
    // Connector 2
    { x0: 1100, y0: 240, x1: 1210, y1: 250},
    { x0: 1100, y0: 350, x1: 1210, y1: 360},
];

const areas = [
    { x0: 10, x1: 200, y0: 10, y1: 400 },
    { x0: 200, x1: 310, y0: 210, y1: 400 },
    { x0: 310, x1: 500, y0: 10, y1: 600 },
    { x0: 610, x1: 800, y0: 10, y1: 600 },
    { x0: 800, x1: 910, y0: 10, y1: 200 },
    { x0: 800, x1: 910, y0: 410, y1: 600 },
    { x0: 910, x1: 1100, y0: 10, y1: 600 },
    { x0: 1210, x1: 1400, y0: 10, y1: 400 },
    { x0: 1400, x1: 1510, y0: 210, y1: 400 },
    { x0: 1510, x1: 1700, y0: 10, y1: 600 },
    { x0: 500, x1: 610, y0: 250, y1: 350 },
    { x0: 1100, x1: 1210, y0: 250, y1: 350 },
];

const getInitialSnake = (() => {
    return [
        { x: 100, y: 200 },
        { x: 100, y: 190 },
    ];
});

const getAreaDots = () => {
    let dots = {};
    areas.forEach((area) => {
        for(let x = area.x0; x < area.x1; x += 10) {
            for(let y = area.y0; y < area.y1; y += 10) {
                let ident = x + ',' + y;
                if(typeof dots[ident] === 'undefined') {
                    dots[ident] = { x, y };
                }
            }
        }
    });
    return dots;
};

const areaDots = getAreaDots();

export { walls, areas, getInitialSnake, areaDots };


// WEBPACK FOOTER //
// ./src/game/map.js